<h2 mat-dialog-title>
  ADD PLAYER
</h2>

<mat-form-field appearance="fill" style="width: 100%;">
  <!--  <mat-label>Search player</mat-label> -->
  <input matInput
    [value]="userInput() || ''"
    (input)="onInputChange($event)"

    placeholder="Type to search..." />
    <!-- (input)="userInput.set($event.target.value); search()" -->
  </mat-form-field>

  <div mat-dialog-content >

    <mat-selection-list
      [multiple]="false"
      [disabled]="isLoading()"
      (selectionChange)="onPlayerSelected($event.options[0]?.value)">
      @for (player of filteredPlayers(); track player.PlayerId) {
        <mat-list-option [value]="{SelectedPlayer: player.LifelineScoutingId, LastName: player.LastName, FirstName: player.FirstName}" [selected]="selectedPlayer() === player.LifelineScoutingId">
          <span matListItemTitle>{{player.LastName}}, {{player.FirstName}} ({{this.positionNames[player.PositionId]}})</span>
          <span matListItemLine>{{player.DateOfBirth | date:'yyyy-MM-dd'}}</span>
        </mat-list-option>
      }
    </mat-selection-list>

    <!--      <mat-selection-list #playerlist style="height: 350px; " [multiple]="false" [(ngModel)]="this.selectedPlayer">
    <mat-list-option *ngFor="let player of this.filteredPlayers"[value]="{SelectedPlayer: player.LifelineScoutingId, LastName: player.LastName, FirstName: player.FirstName}">
      <!--  <button mat-raised-button (click)="addPlayer(player.LifelineScoutingId)">
      ADD
    </button>
    <span matListItemTitle>{{player.LastName}}, {{player.FirstName}} ({{this.positionNames[player.PositionId]}})</span>
    <span matListItemLine>{{player.DateOfBirth | date:'yyyy-MM-dd'}}</span>
  </mat-list-option>

</mat-selection-list> -->
</div>

<div mat-dialog-actions>

  <button mat-button [mat-dialog-close]="this.selectedPlayer()" cdkFocusInitial >{{ data.Action }}</button>
  <button mat-button [mat-dialog-close]="" >{{'GENERAL.CANCEL' | translate | uppercase }}</button>


</div>